import React, { PropsWithChildren, ReactElement } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';

import './FloatingCta.css';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { Button, Row, Col } from '../../importCL';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
interface IFloatingCtaProps extends MappedComponentProperties {
    targetElement?: string;
    buttonText?: string;
    buttonUrl?: string;
}

export const FloatingCtaEditConfig = {
    emptyLabel: 'Floating Cta',
    isEmpty: (props: PropsWithChildren<IFloatingCtaProps>) => {
        return !props || !props.targetElement;
    },
};

const FloatingCta = (props: PropsWithChildren<IFloatingCtaProps>): JSX.Element => {
    const { isElementVisible } = useIntersectionObserver(props.targetElement || '', false, 0, 0, undefined);
    return (
        <div id='floating-cta' className={`FloatingCta ${isElementVisible === false ? 'FloatingCta--peek': '' } ${props.isInEditor ? 'FloatingCta--editor' : ''}`}>
            <Row justify='center'>
                <Col xs={6}>
                    <Button
                        className='FloatingCta__cta'
                        id='Floating_CTASubmit'
                        size='medium'
                        href={props.buttonUrl}>
                        {transformHTMLParserLinks(wrapTrademarkSuperscript(props.buttonText)) as unknown as ReactElement}
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default FloatingCta;
